import { TServiceId, TServices } from 'types/services';

const getServiceName = (id: TServiceId, services?: TServices) => {
  const service = services?.find((item) => Number(item[0]) === Number(id));

  return service ? service[1] : 'Неизвестный сервис';
};

export default getServiceName;
